/**
 * @typedef {(ATTACK | DIE | IDLE)} TypeAnimation An animation.
 */

/**
 * The 'ATTACK' animation.
 * @type {'attack'}
 * @constant
 */
const ATTACK = 'attack';

/**
 * The 'DIE' animation.
 * @type {'die'}
 * @constant
 */
const DIE = 'die';

/**
 * The 'IDLE' animation.
 * @type {'idle'}
 * @constant
 */
const IDLE = 'idle';

export {

    ATTACK,
    DIE,
    IDLE
};
